export function xCoord(d) {
  return d.y;
}

export function yCoord(d) {
  return d.x;
}
